export default {
  authenticationHeaders: {
    'x-api-user': 'system.user@local.local',
    'x-api-key': 'zigaApiKey2023SoZiNa!',
  },
};
